
const getAuthToken = () => {
  try {
    const tokenData = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (!tokenData) return null;
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.access || parsed.access_token || parsed.token;
    } catch {
      // Token is a raw JWT string, not JSON
      return tokenData;
    }
  } catch (e) {
    console.error("Error retrieving auth token:", e);
  }
  return null;
};

export const getLegalTranslations = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getLegalTranslationMappedSummary = async () => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/mapped-summary`,
        {
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Translation mapped summary");
    }
    return response.json();
};

export const getLegalTranslationsInternal = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/internal/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Internal Legal Translation requests");
    }
    return response.json();
};

export const getLegalTranslationInternal = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Internal Legal Translation request");
    }
    return response.json();
};

export const getLegalTranslationsByStakeHolderID = async (stack_holder_id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/by-stakeholder/?stakeholder_id=${stack_holder_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getLegalTranslationsByProsecutorID = async (prosecutor_user_id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/by-prosecutor/?prosecutor_user_id=${prosecutor_user_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getLegalTranslationsInternalByProsecutor = async (prosecutor_user_id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/internal-by-prosecutor/?prosecutor_user_id=${prosecutor_user_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Internal Legal Translation requests by prosecutor");
    }
    return response.json();
};

export const getLegalTranslation = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getLegalTranslationPublic = async (id: string) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/${id}/`,
        {
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Translation public request");
    }
    return response.json();
};

export const getLegalTranslationsExternal = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/external/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get External Legal Translation requests");
    }
    return response.json();
};

export const createLegalTranslation = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

// Note: Using the same endpoint but with is_internal flag in the data
// export const createLegalTranslationInternal = async (data: FormData) => {
//     const response = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/internal/`,
//         {
//             method: "POST",
//             body: data
//         }
//     );
//     if (!response.ok) {
//         const errorBody = await response.text();
//         console.log(errorBody);
//         throw new Error("Failed to create Internal Legal Translation request");
//     }
//     return response.json();
// };

export const updateLegalTranslation = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update Legal Advisory request");
    }
    return response.json();
};


export const createLegalTranslationFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createLegalTranslationRespondbackFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-respond-back-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};


export const createLegalTranslationRemark = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-remarks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createLegalTranslationProsecutorAssignment = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateLegalTranslationProsecutorAssignment = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const deleteLegalTranslationProsecutorAssignment = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE"
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to delete legal translation prosecutor assignment");
    }
};

export const createLegalTranslationAdditionalInfo = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-additional-infos/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateLegalTranslationAdditionalInfo = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-additional-infos/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const uploadLegalTranslationDocument = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_translation/legal-translation-documents/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to upload legal translation document");
    }
    return response.json();
};
